import hateoas from 'viralstyle-ui/src/hateoas';
import storage from 'viralstyle-ui/src/storage';
import requestService from 'viralstyle-ui/src/requestService';

class OrdersApi {
  getOrders(collection) {
    let routeName,
      url,
      params = {
        clientId: storage.get('client-hash'),
        page: collection.page,
        limit: collection.limit,
      };

    if (collection.campaignId) {
      routeName = collection.type !== 'breakdown' ? 'search_client_campaign_orders' : 'single_client_campaign_orders_breakdown';
      params.campaignId = collection.campaignId;
    } else {
      routeName = collection.type !== 'breakdown' ? 'client_campaign_orders' : 'client_campaign_orders_breakdown';
    }

    url = `${hateoas.url(routeName)}?page={page}&limit={limit}`;
    url = url.assignParams(params);

    if (collection.type !== 'all' && collection.type !== 'breakdown') {
      url += `&filters[]=${collection.type}`;
    }

    if (collection.startDate && collection.endDate) {
      url += `&filters[]=created_after:${collection.startDate.toISOString()}&filters[]=created_before:${collection.endDate.toISOString()}`;
    }

    if (collection.query) {
      url += `&filters[]=relates_to:${encodeURIComponent(collection.query)}`;
    }

    if (collection.relaunchCampaignId) {
      url += `&filters[]=campaign_id:${collection.relaunchCampaignId}`;
    }

    url += `&sort=${collection.sortColumn}:${collection.sortDirection === 0 ? 'DESC' : 'ASC'}`

    return requestService.get(url)
  }

  getOrder(orderId) {
    return requestService.get(hateoas.url('client_campaign_order_details', { clientId: storage.get('client-hash'), orderId }));
  }

  exportToCsv(exportUrl) {
    return requestService.get(exportUrl);
  }
}

export default new OrdersApi()